import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemFlowers = function IconSystemFlowers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 7a5 5 0 1 0-5 5m5-5a5 5 0 1 1 5 5m-5-5v1.386M7 12a5 5 0 1 0 5 5m-5-5h1.387M12 17a5 5 0 1 0 5-5m-5 5v-1.386M17 12h-1.385m0 0q0 .099-.006.196a3.6 3.6 0 0 1-1.053 2.36M15.615 12q0-.099-.006-.196a3.6 3.6 0 0 0-1.053-2.36M12 15.614a3.602 3.602 0 0 1-2.555-1.059M12 15.614a3.62 3.62 0 0 0 2.555-1.059M8.387 12q0 .099.005.197c.05.919.443 1.747 1.053 2.358M8.387 12q0-.099.005-.197a3.6 3.6 0 0 1 1.054-2.358M12 8.386q.098 0 .195.005c.92.05 1.749.443 2.36 1.053M12 8.386q-.1 0-.197.006a3.595 3.595 0 0 0-2.358 1.053M17 16.999l-2.444-2.444M7.001 7l2.445 2.445m-2.444 7.554 2.443-2.444M17 7.001l-2.444 2.443"
  }));
};